import React, { useEffect, useState } from "react";
import {
  FormHelperText,
  Stack,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import { processesApi, usersApi } from "api";
import { formatDate, getTranslation } from "common/utilities";
import UserAvatar from "./UserAvatar";
import { StatisticUser } from "model/userModel";
import { ArrowForwardSharp, Refresh } from "@mui/icons-material";
import { useSelectedOrganization, useTranslations } from "hooks";
import { TaskDetailDialog } from "./dialogs";
import { StartedProcess } from "./ProcessItem";
import { Link } from "react-router-dom";
import { BaseTask } from "model/activitiesModel";

export interface TaskDetail extends BaseTask {
  process_description: string;
  process_enddate: string | null;
  process_idprocessmodel: number;
  process_startdate: string | null;
  process_userdata: string;
  processduration: number;
  processmodeldeleted: boolean;
  flownodetype: number;
  idtype: number;
  iduser: number;
  previous: number;
  taskduration: number | null;
  timeindoing: number;
  timetotakeover: number;
  userfullname: string | null;
}
interface TaskItemProps {
  task: TaskDetail;
  process: StartedProcess;
  filters: Record<string, any>;
  lastElementRef?: (node: any) => void;
  refresh: () => void;
}

const TaskItem: React.FC<TaskItemProps> = ({
  lastElementRef,
  filters,
  task,
  process,
  refresh,
}) => {
  const selectedOrganization = useSelectedOrganization();
  const [selectedTask, setSelectedTask] = useState<BaseTask | null>(null);
  const [user, setUser] = useState<StatisticUser | null>(null);
  const translations = useTranslations();

  useEffect(() => {
    (async () => {
      if (task.iduser) {
        const { data } = await usersApi.get(`${task.iduser}`);
        setUser(data.user);
      }
    })();
  }, [task.iduser]);

  const fromDoingTo_Todo = async ({
    idprocesstoken,
  }: {
    idprocesstoken: number;
  }) => {
    try {
      await processesApi.post(`/${idprocesstoken}/undo`);
    } catch {
    } finally {
      // getTasks(all);
    }
  };

  return (
    <React.Fragment>
      <TaskDetailDialog
        readonly
        handleBackStep={(task) => {
          fromDoingTo_Todo(task);
          refresh();
        }}
        open={selectedTask?.idprocesstoken === task.idprocesstoken}
        onClose={() => setSelectedTask(null)}
        doing={selectedTask?.state === 1}
        task={{
          ...task,
          idprocessmodel: task.process_idprocessmodel,
          idorganization: selectedOrganization?.id || 0,
          description: task.process_description,
          assignmentmode: 0,
          idswimlane: 0,
          designerid: "",
          userdata: task.process_userdata,
          jsontag: "",
          priority_name: "",
        }}
      />
      <TableRow
        ref={lastElementRef}
        sx={{
          cursor: "pointer",
          "&:hover": { backgroundColor: (_) => _.palette.divider },
        }}
        onClick={() => setSelectedTask(task)}
      >
        <TableCell>
          <Stack>
            <Stack alignItems="center" spacing={0.5} direction="row">
              <span style={{ fontWeight: "bold" }}>
                {process.process_description}
              </span>
              <ArrowForwardSharp fontSize={"small"} />
              <Link
                onClick={(e) => void e.stopPropagation()}
                to={`/dashboard/process/edit/${process.process_idprocessmodel}`}
                style={{ fontWeight: "bold" }}
              >
                {`${task.processmodelname}`}
              </Link>
            </Stack>
            <FormHelperText>
              {getTranslation(translations, "pm.process.started_at")}
              {formatDate(process.process_startdate)}
            </FormHelperText>
          </Stack>
        </TableCell>
        <TableCell>
          <Stack>
            <Typography>{task.flownodename}</Typography>
            <FormHelperText>
              {getTranslation(translations, "pm.process.started_at")}
              {formatDate(process.process_startdate)}
            </FormHelperText>
          </Stack>
        </TableCell>
        {filters.status === "current" && (
          <TableCell>
            <Typography>
              {task.state === 0
                ? getTranslation(translations, "pm.label.process_status.todo")
                : getTranslation(translations, "pm.label.process_status.doing")}
            </Typography>
          </TableCell>
        )}
        <TableCell>
          {task.iduser ? (
            <Stack direction="row" spacing={0.5}>
              <UserAvatar user={user} />
              <Typography>{task.userfullname}</Typography>
            </Stack>
          ) : (
            <Typography>Participant (WIP)</Typography>
          )}
        </TableCell>
        {/* {!filters.moxdelid && <TableCell>{task.processmodelname}</TableCell>} */}
      </TableRow>
    </React.Fragment>
    // <ListItem>
    //   <Card elevation={0}>
    //     <Stack direction="row" alignItems="center">
    //       <CardContent sx={{ p: "0px!important", m: 0 }}>
    //         <Stack direction="column" justifyContent="center" spacing={1}>
    //           <Typography variant="h6">{task.flownodename}</Typography>
    //           <FormHelperText>
    //             {`created at ${formatDate(task.created)}`}
    //           </FormHelperText>
    //           {task.state === TaskStates.DOING && (
    //             <Stack direction="row" alignItems="center" spacing={1}>
    //               <UserAvatar user={user} />
    //               <FormHelperText>
    //                 {`Under processing by ${task.userfullname} since ${formatDate(task.startdoing)}`}
    //               </FormHelperText>
    //             </Stack>
    //           )}
    //         </Stack>
    //       </CardContent>
    //       {/* <CardActions>actions</CardActions> */}
    //     </Stack>
    //   </Card>
    // </ListItem>
  );
};

export default TaskItem;
